import { useSelector } from 'react-redux';

export default function useCheckAuth() {
  const isLogged = useSelector(state => state.common.isLogged);
  return isLogged;
}
